import { getDatasetArrayByNode, removeElementDom } from '../../utils/dom-utils';
import { initDatalayerElement } from '../tracking/datalayer';
import { isMobile, isWidthDeviceMobileTablet } from '../../utils/device-utils';
import { isHomePage, isEntertainmentDomain } from '../../utils/aem-utils';
import { isHomepageInArticle, isInjectedHPInView } from '../../utils/injected-hp-utils';

const TG24 = 'skytg24';
const ENTERTAINMENT = 'spettacolo';
const SPORT = 'sporthd';
const RAIL_CONTENT_PARSELY = '.c-rail-content.c-rail-content--parsely';
const fallBackSvg =
  '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 461.8 120" class="icon__svg icon__svg--Sky_TG24_SECONDARY_RGB" fill="currentColor" width="80" height="80"><defs><linearGradient id="Sky_TG24_SECONDARY_RGB__b_tv-card" x1="326.73" x2="326.73" y2="120" gradientUnits="userSpaceOnUse"><stop offset=".4" stop-color="#e90e10"/><stop offset="1" stop-color="#bc0000"/></linearGradient><linearGradient id="Sky_TG24_SECONDARY_RGB__a_tv-card" x1="87.68" y1="63.17" x2="86.28" y2="22.98" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff"/><stop offset=".12" stop-color="#fff" stop-opacity=".83"/><stop offset=".27" stop-color="#fff" stop-opacity=".66"/><stop offset=".42" stop-color="#fff" stop-opacity=".51"/><stop offset=".57" stop-color="#fff" stop-opacity=".4"/><stop offset=".72" stop-color="#fff" stop-opacity=".32"/><stop offset=".86" stop-color="#fff" stop-opacity=".27"/><stop offset="1" stop-color="#fff" stop-opacity=".25"/></linearGradient><linearGradient id="Sky_TG24_SECONDARY_RGB__c_tv-card" x1="327.43" y1="56.9" x2="325.35" y2="-2.86" xlink:href="#Sky_TG24_SECONDARY_RGB__a_tv-card"/></defs><rect x="191.66" width="270.14" height="120" rx="8" fill="url(#Sky_TG24_SECONDARY_RGB__b_tv-card)"/><path d="M119.89 111.37a19.89 19.89 0 0 0 8 1.7c6.27.14 9.68-2.26 12.22-7.87l33.59-74.84a18.43 18.43 0 0 0-7-1.62c-4.34-.09-10.15.79-13.84 9.62L142 64l-21.33-34.7a30.91 30.91 0 0 0-7.19-1c-7.56 0-11.76 2.77-16.14 7.51L76.59 58.43l16.69 26.24c3.09 4.79 7.15 7.22 13.75 7.22a24.58 24.58 0 0 0 9.59-1.79L96.51 59.86l14.25-15.1 23.38 36.64zm-44.1-28.31c0 5.52-2.17 8.7-13 8.7a25.58 25.58 0 0 1-3.79-.28V18.3c0-5.57 1.89-11.38 12.77-11.38a19.35 19.35 0 0 1 4.06.42zM53.53 72c0 10.31-6.73 17.81-20.42 19.29-9.92 1.06-24.26-.19-31.08-1a19 19 0 0 1-.42-3.59c0-9 4.85-11 9.41-11 4.75 0 12.22.83 17.75.83 6.13 0 8-2.07 8-4 0-2.58-2.44-3.63-7.19-4.56l-13-2.48C5.76 63.36 0 55.9 0 48c0-9.62 6.82-17.67 20.24-19.14 10.15-1.11 22.5.13 29.28 1a17.27 17.27 0 0 1 .37 3.45c0 9-4.75 10.91-9.31 10.91-3.51 0-8.95-.64-15.17-.64s-8.95 1.75-8.95 3.86 2.49 3.18 6.46 3.87l12.4 2.3C48.05 55.9 53.53 63.13 53.53 72z" fill="#ebebeb"/><path d="m173.7 30.36-12.31 27.39a5.69 5.69 0 0 1-5.12 3.25l-11.27.35a3.2 3.2 0 0 0-2.75 2l10.61-25c3.69-8.83 9.5-9.71 13.84-9.62a18.43 18.43 0 0 1 7 1.63zM141.47 63.1l-20.8-33.8a30.91 30.91 0 0 0-7.19-1c-7.56 0-11.76 2.77-16.14 7.51L76.59 58.43 78.25 61a5.53 5.53 0 0 0 4.91 2.47L95 63.1a6 6 0 0 1 5.24 2.35l-3.71-5.58 14.25-15.1 9.57 15a6.07 6.07 0 0 0 4.9 2.29l13.6-.48a3.21 3.21 0 0 1 2.62 1.52zM71.73 6.92C60.85 6.92 59 12.73 59 18.3v50.15a4.26 4.26 0 0 1 4.14-4.24l8.43-.29a4.27 4.27 0 0 0 4.26-4.28V7.34a19.35 19.35 0 0 0-4.1-.42zM35.32 53.55l-12.4-2.3c-4-.69-6.46-1.61-6.46-3.87s2.63-3.86 9-3.86 11.66.64 15.17.64c4.56 0 9.31-1.93 9.31-10.91a17.27 17.27 0 0 0-.37-3.45c-6.78-.83-19.13-2.07-29.28-1C6.82 30.31 0 38.36 0 48a16.54 16.54 0 0 0 6.56 13.07 25 25 0 0 0 10 3.56 85.85 85.85 0 0 0 13.88.73l14.8-.52c5.55-.19 8.55 4.55 8.24 9.29v-.25c0-.61.07-1.23.07-1.87-.02-8.88-5.5-16.11-18.23-18.46z" fill="url(#Sky_TG24_SECONDARY_RGB__a_tv-card)"/><path d="M251.19 86.22a38.28 38.28 0 0 1-16.25 3.89c-11.19 0-17.91-6.6-17.91-17.55V23.91c0-2.48 1.42-4.13 5.19-4.13a21 21 0 0 1 4.47.59v12.25h22a29.33 29.33 0 0 1 .35 3.89c0 3.42-1.41 4.59-3.53 4.59h-18.82v30.75c0 6.6 3.06 9.78 9.31 9.78 5.65 0 8.83-2.48 11.54-2.48s4.24 2.36 3.65 7.07zM310.46 32.39v51.36c0 14.84-11 24.26-28 24.26a55 55 0 0 1-22.62-5.3c-.58-5.54 1.18-7.77 3.66-7.77 1.41 0 2.82.7 5.18 1.65a36.19 36.19 0 0 0 13.66 3.06c11.19 0 18.5-5.3 18.5-16.14v-3.89c-3.3 4.48-10.13 8.72-19.44 8.72-13.66 0-26.27-11-26.27-28.51s12.72-28.5 26.39-28.5c9.07 0 15.9 4.24 19.44 9v-4.6c0-2.23 1.29-3.76 4.94-3.76a21.75 21.75 0 0 1 4.56.42zm-9.66 18a19 19 0 0 0-17.32-10.84c-10.48 0-18.61 7.54-18.61 20.26s8.13 20.28 18.61 20.28a19.23 19.23 0 0 0 17.32-10.83z" fill="#fff"/><g data-name="24" fill="#fff"><path d="M322.29 88.31a18.52 18.52 0 0 1-.85-5.15c0-2.68.38-5.36 5-8.63l20.06-14.42c10-7.19 14.48-11.55 14.48-18.35 0-7.31-5.65-12.23-14.06-12.23a43.67 43.67 0 0 0-16.86 3.86l-.48.19a11.47 11.47 0 0 1-4.28 1.18 3.63 3.63 0 0 1-2.83-1.23c-1.13-1.31-1.57-3.53-1.23-6.29 5-2.62 14.82-6.88 26.24-6.88 14.6 0 23.67 7.82 23.67 20.41 0 9.34-4.19 15.51-16.61 24.46l-19.17 13.91H372a16.07 16.07 0 0 1 .46 4c0 4.31-1.63 5.15-4.45 5.15zM419.67 89a18.6 18.6 0 0 1-4.31-.6V72.49h-37.68a24.66 24.66 0 0 1-.47-4.17c0-2.57.27-4.71 3.7-8.86l28.68-34.76c2-2.25 3.43-3.63 7.67-3.63a29.3 29.3 0 0 1 7.7 1.15V63.6h12.36a33.27 33.27 0 0 1 .35 4.16c0 3-1.32 4.73-3.73 4.73h-9v12.79C425 87 424.36 89 419.67 89zm-31.16-25.4h26.85V31z"/></g><path d="M197.42 59.54h.75c23.67-.84 257.66-9 257.66-9a6 6 0 0 0 6-6.07V8a8 8 0 0 0-8-8H199.66a8 8 0 0 0-8 8v57.76a6.07 6.07 0 0 1 5.76-6.22z" opacity=".35" fill="url(#Sky_TG24_SECONDARY_RGB__c_tv-card)"/></svg>';

// Init tvCardRailChangePosition
export const init = ($tvCardRail) => {
  if (isMobile() && isHomePage() && !isEntertainmentDomain() && isWidthDeviceMobileTablet()) {
    const railContent = document.querySelector(RAIL_CONTENT_PARSELY);
    if (railContent) {
      const $tvCardRailParent = $tvCardRail.parentNode;
      const $tvCardRailParentClone = $tvCardRailParent.cloneNode(true);
      removeElementDom($tvCardRailParent);
      railContent.parentNode.insertAdjacentElement('afterend', $tvCardRailParentClone);
    }
  }
};

const tvCardMarkupTg = (data) => {
  const width = document.body.clientWidth;
  const TABLET_VIEW = 768;
  let imgSrc;
  let imgSrc2x;
  let svgElement = data.svg ? data.svg : null;
  if (svgElement === null) {
    svgElement = fallBackSvg;
  }
  if (width >= TABLET_VIEW) {
    imgSrc = data.image;
    imgSrc2x = data.image2x;
  } else {
    imgSrc = data.imagesmall;
    imgSrc2x = data.imagesmall2x;
  }

  return `
    <img crossorigin="anonymous" class="c-tv-card__bg-img" alt='Diretta TV'
    src = '${imgSrc}'
    srcset ="${imgSrc} 1x,
    ${imgSrc2x} 2x ">
    <div class="c-tv-card__header">
        <div class="c-tv-card__main">
        <i class="icon icon--logo icon--sky-tg24">
        ${svgElement}
        </i>
          <h2 class="c-section-title  c-section-title--no-margin-top" data-shadow="Diretta TV">
            Diretta TV
          </h2>
        </div>
        <div class="c-tv-card__live">
            <span class="c-label  c-label--live">live</span>
        </div>
    </div>
    <div class="c-tv-card__media-wrapper">
        <div class="o-aspect-ratio o-aspect-ratio--16-10">
        </div>
    </div>
    <div class="c-tv-card__cta">
        <a class="c-cta  c-cta--primary-on-dark " href="${data.href}" data-intcmp="${
          data.intcmpmobile ? data.intcmpmobile : ''
        }">
        <span class="c-cta__text">${data.cta}</span>
        <i class="icon icon--arrow-navigation icon--arrow-link  icon--c-primary"><svg viewBox="0 0 80 80"
                    xmlns="http://www.w3.org/2000/svg" class="icon__svg icon__svg--arrow-link" fill="currentColor"
                    width="80" height="80">
                    <path
                        d="M67.488 35.963L56.259 25.458c-1.328-1.242-1.335-3.264-.017-4.515 1.319-1.251 3.464-1.258 4.792-.016l17.965 16.807c1.393 1.304 1.323 3.446-.153 4.666L58.518 59.207c-1.407 1.163-3.548 1.031-4.782-.294s-1.094-3.342.312-4.505l14.587-12.06H3.388C1.517 42.348 0 40.918 0 39.155c0-1.763 1.517-3.192 3.388-3.192h64.1z"
                        fill="currentColor" fill-rule="evenodd"></path>
                </svg></i>
        </a>
    </div>
  </div>
  `;
};

export const initTvCardRail = ({ $tvCard, isLive, isLiveDesktop }) => {
  console.info('[TV - CARD] init TV card RAIL');
  const data = getDatasetArrayByNode($tvCard);

  switch (data.theme) {
    case TG24:
      if (isLive && !isLiveDesktop) {
        $tvCard.innerHTML = '';
        $tvCard.classList.add('c-tv-card--bg-image');
        $tvCard.classList.add('c-tv-card--with-cta');
        $tvCard.innerHTML = tvCardMarkupTg(data);
        init($tvCard);
        initDatalayerElement($tvCard);
        break;
      }

      if (isHomepageInArticle() && isInjectedHPInView()) {
        const videoContainer = $tvCard.querySelector('.j-player') || null;
        if (videoContainer) {
          videoContainer.parentNode.innerHTML = '';
        }
        break;
      }

      removeElementDom($tvCard);
      break;

    case ENTERTAINMENT:
      $tvCard.innerHTML = '';

      init($tvCard);
      break;

    case SPORT:
      removeElementDom($tvCard);
      break;

    default:
      console.error('generic error tv-card no theme definite');
      removeElementDom($tvCard);
      break;
  }
};
